import styled from 'styled-components';
import PcCheckIcon from '@/assets/pc/PcCheck.svg?react';
import ArrowWhiteIcon from '@/assets/mo/ArrowWhite.svg?react';

const Verification = () => {
  return (
    <SectionWrapper>
      <ContentWrapper>
        <LeftBox>
          <PcCheckIcon />
        </LeftBox>

        <RightBox>
          <TextGroup>
            <Title>보험금 청구 후,</Title>
            <HighlightTitle>보험금 얼마나 받을 수 있을까?</HighlightTitle>
            <Description>병원 서류와 증권만 있으면 알 수 있어요</Description>
          </TextGroup>

          <ApplyButton
            onClick={() => (window.location.href = 'https://allbadeum.wixsite.com/my-site-1')}
          >
            <ButtonInner>
              <ButtonText>보험금 알아보기</ButtonText>
              <ArrowWhiteIcon />
            </ButtonInner>
          </ApplyButton>
        </RightBox>
      </ContentWrapper>
    </SectionWrapper>
  );
};

export default Verification;

// ================== Styled Components ==================

const SectionWrapper = styled.section`
  display: flex;
  align-items: center;
  justify-content: center; // ✅ 좌우 가운데 정렬
  background: #fff;

  @media (max-width: 900px) {
    flex-direction: column;
    padding: 40px 20px;
    gap: 40px;
  }
`;

const ContentWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 209px;

  @media (max-width: 900px) {
    flex-direction: column;
    gap: 32px;
  }
`;

const LeftBox = styled.div`
  display: flex;
  height: 580px;

  justify-content: flex-end;
  align-items: center;

  svg {
    width: 254.525px;
    height: 236.222px;
  }

  @media (max-width: 900px) {
    padding: 0;
    height: auto;
    justify-content: center;

    svg {
      width: 180px;
      height: auto;
    }
  }
`;

const RightBox = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 48px;

  @media (max-width: 900px) {
    gap: 32px;
  }
`;

const TextGroup = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 10px;
  align-self: stretch;

  @media (max-width: 900px) {
    align-items: center;
  }
`;

const Title = styled.div`
  align-self: stretch;
  color: var(--color-text-text-500, #000c24);
  font-family: 'Noto Sans KR';
  font-size: 32px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
  letter-spacing: -0.64px;
  text-align: start;

  @media (max-width: 900px) {
    font-size: 24px;
  }
`;

const HighlightTitle = styled.div`
  color: var(--color-main-main-500, #0b46dd);
  font-family: 'Noto Sans KR';
  font-size: 32px;
  font-style: normal;
  font-weight: 700;
  line-height: 150%;
  letter-spacing: -0.64px;

  @media (max-width: 900px) {
    font-size: 24px;
  }
`;

const Description = styled.div`
  text-align: start;
  align-self: stretch;
  color: var(--color-text-text-300, #545c6c);
  font-family: 'Noto Sans KR';
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
  letter-spacing: -0.32px;

  @media (max-width: 900px) {
    font-size: 14px;
  }
`;

const ApplyButton = styled.button`
  display: flex;
  height: 45px;
  padding: 0px 40px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  border-radius: 8px;
  background: #0b46dd;
  border: none;
  cursor: pointer;

  @media (max-width: 900px) {
    width: 100%;
    padding: 0px 20px;
  }
`;

const ButtonInner = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 2px;
`;

const ButtonText = styled.span`
  color: #fff;
  text-align: right;
  font-family: 'Noto Sans KR';
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
`;
